import { ProductType } from 'selfServicePortal/interfaces/i-api-support'
import { DocumentTypes } from 'shared'
import appConfig from '../../app.config'
import { SigningUrlType } from './signingTypes'

export const apiRoutes = {
	adminPing: `/api/admin/ping`,
	idCardAuth: (id: string) =>
		`${appConfig.authorityBaseUrl}/apiauth/idcard/${id || ''}`,
	mobileIdAuthInitiate: `${appConfig.authorityBaseUrl}/apiauth/mobileid/initiate`,
	mobileIdAuthComplete: `${appConfig.authorityBaseUrl}/apiauth/mobileid/complete`,
	smartIdAuthInitiate: `${appConfig.authorityBaseUrl}/apiauth/smartid/initiate`,
	smartIdAuthComplete: `${appConfig.authorityBaseUrl}/apiauth/smartid/complete`,
	signicatAuthLink: `${appConfig.authorityBaseUrl}/apiauth/signicat/link`,
	signicatAuthResult: `${appConfig.authorityBaseUrl}/apiauth/signicat/result`,
	signicatAuthMitId: `${appConfig.authorityBaseUrl}/apiauth/signicat/mitid`,
	norwegianBankIdAuthLink: `${appConfig.authorityBaseUrl}/apiauth/norwegianbankid/link`,
	norwegianBankIdAuthResult: `${appConfig.authorityBaseUrl}/apiauth/norwegianbankid/result`,
	norwegianBankIdApplicationAuthResult: `${appConfig.authorityBaseUrl}/apiauth/norwegianbankid/application/result`,
	bankIdv2AuthInitiate: `${appConfig.authorityBaseUrl}/v2/apiauth/bankid/initiate`,
	bankIdv2AuthCollect: `${appConfig.authorityBaseUrl}/v2/apiauth/bankid/collect`,
	bankIdv2AuthCancel: `${appConfig.authorityBaseUrl}/v2/apiauth/bankid/cancel`,
	bankIdv2GenerateQrCode: `${appConfig.authorityBaseUrl}/v2/apiauth/bankid/qrcode/generate`,

	germanyAuthenticate: `${appConfig.authorityBaseUrl}/apiauth/germany/authenticate`,
	germanyOtpStart: `${appConfig.authorityBaseUrl}/apiauth/germany/authenticate/otp/start`,
	germanyOtpComplete: `${appConfig.authorityBaseUrl}/apiauth/germany/authenticate/otp/complete`,

	italyAuthenticate: `${appConfig.authorityBaseUrl}/apiauth/Italy/authenticate`,
	italyOtpStart: `${appConfig.authorityBaseUrl}/otpauth/application/start`,
	italyOtpStartSsp: `${appConfig.authorityBaseUrl}/apiauth/Italy/authenticate/otp/start`,
	italyOtpCompleteSsp: `${appConfig.authorityBaseUrl}/apiauth/Italy/authenticate/otp/complete`,

	austriaOtpStart: `${appConfig.authorityBaseUrl}/apiauth/austria/authenticate/otp/start`,
	austriaOtpComplete: `${appConfig.authorityBaseUrl}/apiauth/austria/authenticate/otp/complete`,

	spainAuthenticate: `${appConfig.authorityBaseUrl}/apiauth/Spain/authenticate`,
	spainOtpStart: `${appConfig.authorityBaseUrl}/otpauth/application/start`,
	spainOtpStartSsp: `${appConfig.authorityBaseUrl}/apiauth/Spain/authenticate/otp/start`,
	spainOtpComplete: `${appConfig.authorityBaseUrl}/otpauth/complete`,
	spainOtpCompleteSsp: `${appConfig.authorityBaseUrl}/apiauth/Spain/authenticate/otp/complete`,

	loanOtpStart: `${appConfig.authorityBaseUrl}/otpauth/loan/start`,
	electronicIDToken: (applicationId: string, product: string) =>
		`${appConfig.authorityBaseUrl}/apiauth/signicat/electronicid/videoid?applicationId=${applicationId}&product=${product}`,
	electronicIDVerificationRequest: `${appConfig.customerDataBaseUrl}/api/ApplicationPage/electronicid/verification`,
	redirectTo: `${appConfig.authorityBaseUrl}/account/redirectto`,
	getArtifactBbBank: (requestId: string, taskId: string) =>
		`${appConfig.authorityBaseUrl}/apiauth/norwegianbankid/artifact?requestId=${requestId}&taskId=${taskId}`,
	getArtifactDk: (requestId: string, taskId: string) =>
		`${appConfig.authorityBaseUrl}/apiauth/signicat/dkartifact?requestId=${requestId}&taskId=${taskId}`,
	getArtifactFi: (requestId: string, taskId: string) =>
		`${appConfig.authorityBaseUrl}/apiauth/signicat/artifact?requestId=${requestId}&taskId=${taskId}`,
	getLoansData: (country: string) =>
		`${appConfig.customerDataBaseUrl}/api/loan/loans?countryCode=${country}`,
	getRepaymentPlan: (id: string) =>
		`${appConfig.customerDataBaseUrl}/api/loan/repaymentplan?repaymentPlanId=${id}`,
	updateSubscription: `${appConfig.customerDataBaseUrl}/api/user/details`,
	sendEmail: `${appConfig.customerDataBaseUrl}/api/support/email`,
	getApplicationInformation: (applicationId: number) =>
		`${appConfig.customerDataBaseUrl}/api/ApplicationPage/applicationinformation?applicationId=${applicationId}`,
	getSigningUrl: (applicationId: number, signingUrl: SigningUrlType) =>
		`${appConfig.customerDataBaseUrl}/api/ApplicationPage/signingurls?applicationId=${applicationId}&signingurltype=${signingUrl}`,
	uploadDocument: (applicationId: number) =>
		`${appConfig.customerDataBaseUrl}/api/ApplicationPage/document/uploaddocument?applicationId=${applicationId}`,
	getDocument: (applicationId: string, documentType: DocumentTypes) =>
		`${appConfig.customerDataBaseUrl}/api/ApplicationPage/document/downloaddocument?applicationId=${applicationId}&documentType=${documentType}`,
	getKycData: `${appConfig.customerDataBaseUrl}/api/user/kyc`,
	updateKycCustomerData: `${appConfig.customerDataBaseUrl}/api/user/kyc`,
	lookupAddressInAddressService: (inputAddress: string) =>
		`${appConfig.customerDataBaseUrl}/api/user/addressService?inputAddress=${inputAddress}`,
	getDepositsData: `${appConfig.customerDataBaseUrl}/api/deposit/deposits`,
	getDepositsDataV2: `${appConfig.customerDataBaseUrl}/api/v2/deposit/deposits`,
	getCustomerDetails: `${appConfig.customerDataBaseUrl}/api/deposit/customer`,
	getCustomerDetailsV2: `${appConfig.customerDataBaseUrl}/api/v2/deposit/customer`,
	updateCustomerData: `${appConfig.customerDataBaseUrl}/api/deposit/customer`,
	updateCustomerDataV2: `${appConfig.customerDataBaseUrl}/api/v2/deposit/customer`,
	updatePpi: `${appConfig.customerDataBaseUrl}/api/ApplicationPage/updateppi`,
	updateSbl: `${appConfig.customerDataBaseUrl}/api/ApplicationPage/updatesbl`,
	updateMissingKyc: `${appConfig.customerDataBaseUrl}/api/ApplicationPage/updatekyc`,
	addPublicNote: `${appConfig.customerDataBaseUrl}/api/ApplicationPage/addpublicnote`,
	getFAQ: (country: string, productType: ProductType, lng: string) =>
		`${appConfig.customerDataBaseUrl}/api/customerservice/faq?country=${country}&productType=${productType}&translationLng=${lng}`,
	addTermsAndConditionAccepted: `${appConfig.customerDataBaseUrl}/api/CustomerService/termsandconditions/accept`,
	updateBankInfo: `${appConfig.customerDataBaseUrl}/api/ApplicationPage/updatebankinfo`,
	getDownloadDocuments: (applicationId: string) =>
		`${appConfig.customerDataBaseUrl}/api/ApplicationPage/document/downloaddocuments?applicationId=${applicationId}`,
	getDownloadDocumentById: (documentId: string) =>
		`${appConfig.customerDataBaseUrl}/api/ApplicationPage/document/downloaddocumentbyid?documentId=${documentId}`,
	updateCustomerConsents: `${appConfig.customerDataBaseUrl}/api/ApplicationPage/updateCustomerConsents`,
	printPn: `${appConfig.customerDataBaseUrl}/api/ApplicationPage/printpn`,
	updateLoanData: `${appConfig.customerDataBaseUrl}/api/ApplicationPage/updateloandata`,
	sddEnrollmentInitiate: `${appConfig.customerDataBaseUrl}/api/sepadirectdebit/enroll/initiate`,
	sddEnrollmentComplete: `${appConfig.customerDataBaseUrl}/api/sepadirectdebit/enroll/complete`,
	sddResendOtp: `${appConfig.customerDataBaseUrl}/api/sepadirectdebit/otp/resend`,
	getSddActivePct: (country: string) =>
		`${appConfig.customerDataBaseUrl}/api/sepadirectdebit/pct/${country}`,
	getSddIbans: (partyId: string) =>
		`${appConfig.customerDataBaseUrl}/api/sepadirectdebit/ibans/${partyId}`,
	getSddIsEligible: (partyId: string) =>
		`${appConfig.customerDataBaseUrl}/api/SepaDirectDebit/eligible/${partyId}`,
	getSddMandate: (partyId: string) =>
		`${appConfig.customerDataBaseUrl}/api/SepaDirectDebit/mandate/${partyId}`,
	getSddMandateDocument: (mandateDocumentId: string) =>
		`${appConfig.customerDataBaseUrl}/api/SepaDirectDebit/mandate/download?documentId=${mandateDocumentId}`,
	sddMandateDisable: `${appConfig.customerDataBaseUrl}/api/SepaDirectDebit/mandate/disable`,
	attachVideoIdentification: `${appConfig.esignBaseUrl}/api/esigning/attachVideoIdentification`,
	createVideoIdentity: `${appConfig.esignBaseUrl}/api/esigning/createVideoIdentity`,
	updateApplicationInformation: `${appConfig.customerDataBaseUrl}/api/ApplicationPage/applicationinformation`,
	runmulticashpreliminarydecision: `${appConfig.customerDataBaseUrl}/api/ApplicationPage/multicash/runpreliminarydecision`,
    runcreditcardpreliminarydecision: `${appConfig.customerDataBaseUrl}/api/ApplicationPage/creditcard/runpreliminarydecision`,
    runcreditdecision: `${appConfig.customerDataBaseUrl}/api/ApplicationPage/runcreditdecision`,
    runmulticashcreditdecision: `${appConfig.customerDataBaseUrl}/api/ApplicationPage/multicash/runcreditdecision`,
    runcreditcardcreditdecision: `${appConfig.customerDataBaseUrl}/api/ApplicationPage/creditcard/runcreditdecision`,
	confirmApplication: `${appConfig.customerDataBaseUrl}/api/ApplicationPage/confirmapplication`,
	confirmMultiCashApplication: `${appConfig.customerDataBaseUrl}/api/ApplicationPage/confirmmulticashapplication`,
	signPnInit: `${appConfig.esignBaseUrl}/api/esigning/initiateESigningSpain`,
	signPnComplete: `${appConfig.esignBaseUrl}/api/esigning/completeESigningSpain`,
	signPnResendOtp: `${appConfig.esignBaseUrl}/api/esigning/resendotpESigningSpain`,
	removedirectdebit: `${appConfig.customerDataBaseUrl}/api/ApplicationPage/removedirectdebit`,
	getNordigenBanks: (country: string) =>
		`${appConfig.customerDataBaseUrl}/api/ApplicationPage/nordigen/banks?${country}`,
	getNordigenAgreement: (institutionId: string) =>
		`${appConfig.customerDataBaseUrl}/api/ApplicationPage/nordigen/agreement?${institutionId}`,
	createNordigenRequisitions: `${appConfig.customerDataBaseUrl}/api/ApplicationPage/nordigen/requisitions`,
	getNordigenListAccount: (requisitionId: string) =>
		`${appConfig.customerDataBaseUrl}/api/ApplicationPage/nordigen/listAccount?${requisitionId}`,
	eParakstsAuthLink: `${appConfig.authorityBaseUrl}/apiauth/eparaksts/link`,
	eParakstsAuthResult: `${appConfig.authorityBaseUrl}/apiauth/eparaksts/result`,
}